export enum DirectorsSortBy {
  name = 'individual.fullName',
  role = 'role',
  signingRight = 'signingRight',
  email = 'individual.email',
  phone = 'individual.phone',
}
